{
  "You're invited to watch {title}": "Zapraszamy do oglądania: {title}",
  "Share your event link": "Udostępnij link do wydarzenia",
  "device|desktop": "komputer",
  "device|phone": "telefon",
  "device|tablet": "tablet",
  "device|tv": "telewizor",
  "device|console": "konsola",
  "{hours}h {minutes}m": "{hours} godz. {minutes} min",
  "Sorry, there's been an error loading the analytics data.": "Przepraszamy, podczas wczytywania statystyk wystąpił błąd.",
  "Detailed analytics are available for events starting May 20, 2025. Below are the basic statistics for this event.": "Szczegółowe statystyki są dostępne dla wydarzeń od 20 maja 2025 r. Poniżej znajdziesz podstawowe statystyki tego wydarzenia.",
  "Viewed Live": "Oglądali na żywo",
  "Watched Replay": "Obejrzeli nagranie",
  "Powered by": "Obsługiwane przez",
  "{count} views": {
    "one": "{count} wyświetlenie",
    "few": "{count} wyświetlenia",
    "many": "{count} wyświetleń"
  },
  "{count} viewers": {
    "one": "{count} widz",
    "few": "{count} widzów",
    "many": "{count} widzów"
  },
  "Analytics are kept for 100 days. Export a PDF to keep a copy.": "Statystyki są przechowywane przez 100 dni. Wyeksportuj plik PDF, aby zachować kopię.",
  "Total Views": "Wyświetlenia łącznie",
  "Unique Viewers": "Unikalni widzowie",
  "Total Watch Time": "Łączny czas oglądania",
  "Views": "Wyświetlenia",
  "Watch Time": "Czas oglądania",
  "Top Countries": "Najpopularniejsze kraje",
  "Top Regions / States": "Najpopularniejsze regiony / stany",
  "analytics|Unknown": "Nieznane",
  "Device Categories": "Rodzaje urządzeń",
  "Top Browsers": "Najpopularniejsze przeglądarki",
  "Operating Systems": "Systemy operacyjne",
  "Import": "Importuj",
  "Invite a guest": "Zaproś gościa",
  "We'll email them the event link and remind them before you go live.": "Wyślemy tej osobie e-mail z linkiem do wydarzenia i przypomnimy jej o nim, zanim rozpoczniesz transmisję.",
  "CSV Import": "Import z pliku CSV",
  "Select File": "Wybierz plik",
  "Format: CSV. Required column: Email. Optional columns: Name, First Name, Last Name": "Format: CSV. Wymagana kolumna: „Email”. Opcjonalne kolumny: „Name”, „First Name”, „Last Name” (nagłówki po angielsku)",
  "Invite All ({count})": "Zaproś wszystkich ({count})",
  "Couldn't load the guest list": "Nie udało się wczytać listy gości",
  "Remove the guest from the list?": "Usunąć gościa z listy?",
  "guest status|Joined Live": "Oglądano na żywo",
  "guest status|Watched Replay": "Obejrzano nagranie",
  "guest status|Visited page": "Odwiedzono stronę",
  "guest status|Invited": "Wysłano zaproszenie",
  "{count} guest": {
    "one": "{count} gość",
    "few": "{count} gości",
    "many": "{count} gości"
  },
  "Open the guest list": "Otwórz listę gości",
  "Guests of every {noun} are on the guest list of {label} (the main link). They sign up once and can watch every {noun}.": "Goście każdej transmisji ({noun}) są na liście gości „{label}” (główny link). Rejestrują się raz i mogą oglądać wszystkie transmisje.",
  "Start inviting guests": "Zacznij zapraszać gości",
  "Invite guests by email or just share your event link with them.": "Zaproś gości e-mailem albo po prostu udostępnij im link do wydarzenia.",
  "Guests who sign the guestbook or ask for reminders appear here too.": "Pojawiają się tu też goście, którzy wpisują się do księgi gości lub proszą o przypomnienia.",
  "Share link": "Udostępnij link",
  "Download guest list": "Pobierz listę gości",
  "Guests {title}.csv": "Goście {title}.csv",
  "Guests.csv": "Goście.csv",
  "{title}-report.pdf": "{title}-raport.pdf",
  "analytics-report.pdf": "raport-statystyk.pdf",
  "Export PDF": "Eksportuj PDF",
  "Invitation sent": "Wysłano zaproszenie",
  "{name} will get reminders before you go live.": "{name} dostanie przypomnienia, zanim rozpoczniesz transmisję.",
  "Couldn't send the invitation": "Nie udało się wysłać zaproszenia",
  "Guest's name": "Imię i nazwisko gościa",
  "e.g. Maria Lopez": "np. Maria Nowak",
  "Send invitation": "Wyślij zaproszenie",
  "Could not open image library.": "Nie udało się otworzyć galerii zdjęć.",
  "Delete Cover?": "Usunąć zdjęcie w tle?",
  "Delete failed": "Nie udało się usunąć",
  "Processing image...": "Przetwarzanie obrazu...",
  "Uploading... {percent}%": "Przesyłanie... {percent}%",
  "Invalid file": "Nieprawidłowy plik",
  "Only JPG or PNG files are accepted": "Akceptowane są tylko pliki JPG lub PNG",
  "Drop image here": "Upuść obraz tutaj",
  "Drop image here or click to select": "Upuść obraz tutaj lub kliknij, aby wybrać",
  "Recommended size: 1280x720 pixels": "Zalecany rozmiar: 1280x720 pikseli",
  "Accepts PNG or JPG under 50MB": "Pliki PNG lub JPG do 50 MB",
  "Couldn't save that": "Nie udało się zapisać",
  "Guests who watch on your website get emails that link back to the page they watched on.": "Goście oglądający na twojej stronie internetowej dostają e-maile z linkiem prowadzącym z powrotem na stronę, na której oglądają.",
  "Pages where guests watch your embed will show up here.": "Tutaj pojawią się strony, na których goście oglądają twój Embed.",
  "Seen on": "Wykryte strony",
  "Use for email links": "Używaj w e-mailach",
  "Ignore": "Ignoruj",
  "Used for email links": "Używane w e-mailach",
  "Stop using": "Przestań używać",
  "Other guests": "Pozostali goście",
  "Your Embed webpage URL from before. Remove it to send everyone else to evt.live.": "Wcześniej ustawiony adres strony z Embed. Usuń go, aby kierować wszystkich pozostałych gości do evt.live.",
  "EventLive event": "Wydarzenie w EventLive",
  "How this event's page looks to guests. It overrides the branding in your profile.": "Tak goście widzą stronę tego wydarzenia. Te ustawienia mają pierwszeństwo przed brandingiem z twojego profilu.",
  "Could not update branding settings": "Nie udało się zaktualizować ustawień brandingu",
  "Event page": "Strona wydarzenia",
  "Description": "Opis",
  "A few words for your guests": "Kilka słów dla gości",
  "Supports Markdown: **bold**, lists and links.": "Obsługuje Markdown: **pogrubienie**, listy i linki.",
  "e.g. 7pm ET / 4pm PT": "np. 19:00 w Warszawie / 18:00 w Londynie",
  "Replaces the date and time on your event page and in reminder emails.": "Zastępuje datę i godzinę na stronie twojego wydarzenia oraz w e-mailach z przypomnieniem.",
  "Company": "Firma",
  "Shown on this event page only. PNG or JPG; it's trimmed and resized automatically. Horizontal logos work best. A white logo on a transparent background may not show on a light page.": "Wyświetlane tylko na stronie tego wydarzenia. PNG lub JPG; logo zostanie automatycznie przycięte i przeskalowane. Najlepiej wygląda logo poziome. Białe logo na przezroczystym tle może być niewidoczne na jasnej stronie.",
  "Put your event page or just the video player on your own website.": "Umieść stronę wydarzenia albo sam odtwarzacz wideo na swojej stronie internetowej.",
  "Layout": "Układ",
  "Full embed": "Pełny Embed",
  "The event page: video, guestbook and reminders.": "Strona wydarzenia: wideo, księga gości i przypomnienia.",
  "Just video": "Tylko wideo",
  "Only the video player.": "Tylko odtwarzacz wideo.",
  "These change the code below. Copy it again after changing them.": "Te opcje zmieniają kod poniżej. Po ich zmianie skopiuj go ponownie.",
  "Autoplay": "Autoodtwarzanie",
  "Start the video automatically.": "Wideo uruchamia się automatycznie.",
  "Reminder button": "Przycisk przypomnień",
  "Guests can sign up for reminders from your website.": "Goście mogą zapisać się na przypomnienia na twojej stronie internetowej.",
  "No replay and no rewind in the embed.": "Bez nagrania i bez przewijania do tyłu w Embed.",
  "Script (recommended)": "Skrypt (zalecany)",
  "Viewers who open an EventLive email link on your page are recognized there, and the player is sized to fit.": "Widzowie, którzy otworzą link z e-maila EventLive na twojej stronie, są tam rozpoznawani, a odtwarzacz dopasowuje swój rozmiar.",
  "Simple iframe (no script)": "Zwykły iframe (bez skryptu)",
  "For site builders that remove scripts. The player can't see viewers' email links, so ticket holders on a new device may have to sign in again.": "Dla kreatorów stron, które usuwają skrypty. Odtwarzacz nie widzi linków z e-maili widzów, więc osoby z biletem mogą być proszone o ponowne zalogowanie się na nowym urządzeniu.",
  "Embed code": "Kod Embed",
  "Copy embed code": "Kopiuj kod Embed",
  "Embed code copied": "Skopiowano kod Embed",
  "Paste it into your website's HTML.": "Wklej go do kodu HTML swojej strony internetowej.",
  "Preview": "Podgląd",
  "Couldn't load the guestbook": "Nie udało się wczytać księgi gości",
  "Delete this message?": "Usunąć tę wiadomość?",
  "Messaging": "Wiadomości",
  "Chat": "Czat",
  "You pinned": "Przypięta przez ciebie",
  "Delete this message": "Usuń tę wiadomość",
  "Could not update messaging settings": "Nie udało się zaktualizować ustawień wiadomości",
  "Guests sign it and add photos. Newest messages first.": "Goście wpisują się do niej i dodają zdjęcia. Najnowsze wiadomości są na górze.",
  "A live chat next to the video, like a group conversation.": "Czat na żywo obok wideo, jak rozmowa grupowa.",
  "Disable messaging": "Wyłącz wiadomości",
  "Guests can watch but can't post messages.": "Goście mogą oglądać, ale nie mogą pisać wiadomości.",
  "{count} message": {
    "one": "{count} wiadomość",
    "few": "{count} wiadomości",
    "many": "{count} wiadomości"
  },
  "Loading messages…": "Wczytywanie wiadomości…",
  "No messages yet. They'll appear here as guests post them.": "Nie ma jeszcze wiadomości. Pojawią się tutaj, gdy goście zaczną je pisać.",
  "Could not update privacy settings": "Nie udało się zaktualizować ustawień prywatności",
  "Hide event page": "Ukryj stronę wydarzenia",
  "Manage tickets": "Zarządzaj biletami",
  "Guests need a ticket to watch. To let some guests in for free, invite them from the Guest List.": "Do oglądania goście potrzebują biletu. Aby wpuścić niektórych gości za darmo, zaproś ich z listy gości.",
  "Anyone with the link can watch": "Każdy, kto ma link, może oglądać",
  "Share the link; no password or invitation needed.": "Udostępnij link – bez hasła i zaproszenia.",
  "Password protected": "Chronione hasłem",
  "Guests enter a password you give them.": "Goście wpisują hasło, które im podasz.",
  "Choose a password": "Wybierz hasło",
  "Invite only": "Tylko dla zaproszonych",
  "Only the guests invited by email can join. One device per email at a time. (MUST be on the <list>Guest List</list>)": "Dołączyć mogą tylko goście zaproszeni e-mailem. Jedno urządzenie na adres e-mail naraz. (MUSZĄ być na <list>liście gości</list>)",
  "Ask guests for their name and email": "Pytaj gości o imię i adres e-mail",
  "Always on for invite-only events.": "Zawsze włączone w wydarzeniach tylko dla zaproszonych.",
  "Before they can watch. They'll appear in your Guest List.": "Zanim zaczną oglądać. Pojawią się na twojej liście gości.",
  "Replay and download": "Nagranie i pobieranie",
  "Show download link to guests": "Pokaż gościom link do pobrania",
  "Hide viewer counter": "Ukryj licznik widzów",
  "Your event page is hidden. People who bought tickets can't watch until you show it again.": "Strona twojego wydarzenia jest ukryta. Osoby, które kupiły bilety, nie mogą oglądać, dopóki ponownie jej nie pokażesz.",
  "Your event page is hidden. Guests can't open it until you show it again.": "Strona twojego wydarzenia jest ukryta. Goście nie mogą jej otworzyć, dopóki ponownie jej nie pokażesz.",
  "Show event page": "Pokaż stronę wydarzenia",
  "Remove {guest} from the guest list": "Usuń z listy gości: {guest}",
  "Message pinned": "Przypięto wiadomość",
  "Guests see it at the top of the guestbook.": "Goście widzą ją na górze księgi gości.",
  "Couldn't pin the message": "Nie udało się przypiąć wiadomości",
  "e.g. Welcome! The ceremony starts at 3 pm.": "np. Witamy! Uroczystość zaczyna się o 15:00.",
  "Stays at the top of the guestbook or chat.": "Pozostaje na górze księgi gości lub czatu.",
  "Pin message": "Przypnij wiadomość",
  "Share on {network}": "Udostępnij: {network}",
  "Share on Email": "Udostępnij e-mailem",
  "Preview my Event Page": "Podgląd strony mojego wydarzenia",
  "Share via:": "Udostępnij przez:",
  "Viewer-hours": "Godziny oglądania",
  "{count} viewer-hour": {
    "one": "{count} godzina oglądania",
    "few": "{count} godziny oglądania",
    "many": "{count} godzin oglądania"
  },
  "Live {live} · Replay {replay}": "Na żywo: {live} · Nagranie: {replay}",
  "Ticketed events have no viewer-hour limit.": "Wydarzenia z biletami nie mają limitu godzin oglądania.",
  "{used} of {limit} viewer-hours included with this event": "{used} z {limit} godzin oglądania zawartych w cenie tego wydarzenia",
  "Over the {limit} viewer-hours included with this event by {over}.": "Przekroczono o {over} limit {limit} godzin oglądania zawartych w cenie tego wydarzenia.",
  "By day (UTC)": "Według dni (UTC)",
  "Show fewer days": "Pokaż mniej dni",
  "Show all {count} days": {
    "one": "Pokaż {count} dzień",
    "few": "Pokaż wszystkie {count} dni",
    "many": "Pokaż wszystkie {count} dni"
  },
  "Viewer-hours are updated every hour. They show here within an hour of people watching.": "Godziny oglądania są aktualizowane co godzinę. Pojawiają się tutaj najpóźniej godzinę po obejrzeniu.",
  "Live viewers": "Widzowie na żywo",
  "Devices watching each minute of the live stream.": "Urządzenia oglądające transmisję na żywo w każdej minucie.",
  "Live viewers per minute from {start} to {end}. Peak: {peak} at {time}.": "Widzowie na żywo w każdej minucie od {start} do {end}. Szczyt: {peak} o {time}.",
  "Peak: {count} at {time}": "Szczyt: {count} o {time}",
  "{count} viewer at {time}": {
    "one": "{count} widz o {time}",
    "few": "{count} widzów o {time}",
    "many": "{count} widzów o {time}"
  },
  "Browsers and apps": "Przeglądarki i aplikacje",
  "{count} viewer": {
    "one": "{count} widz",
    "few": "{count} widzów",
    "many": "{count} widzów"
  },
  "Regions:": "Regiony:",
  "IP Geolocation by DB-IP": "Geolokalizacja IP: DB-IP",
  "Before {date}": "Przed {date}",
  "From our previous analytics, which counted browsers only, saved for good before they expired.": "Z naszych poprzednich statystyk, które liczyły tylko przeglądarki, zapisanych na zawsze, zanim wygasły.",
  "Viewers": "Widzowie",
  "{live} live · {replay} replay only": "{live} na żywo · {replay} tylko nagranie",
  "{time} per viewer": "{time} na widza",
  "Peak live viewers": "Najwięcej widzów na żywo",
  "Watch time, views, countries and devices are counted from {date}. Unique viewers are counted for every event.": "Czas oglądania, wyświetlenia, kraje i urządzenia są liczone od {date}. Unikalni widzowie są liczeni dla każdego wydarzenia.",
  "Viewers here are devices on each day: someone watching on two days counts twice. Counted every hour from the video our CDN delivered, on every player.": "Widzowie to tutaj urządzenia w danym dniu: ktoś, kto ogląda przez dwa dni, jest liczony dwa razy. Liczone co godzinę na podstawie wideo dostarczonego przez naszą sieć CDN, we wszystkich odtwarzaczach.",
  "Each viewer counts once, however many days they watch. Counted every hour from the video our CDN delivered, on every player.": "Każdy widz jest liczony raz, niezależnie od tego, przez ile dni ogląda. Liczone co godzinę na podstawie wideo dostarczonego przez naszą sieć CDN, we wszystkich odtwarzaczach.",
  "Mux, for comparison": "Mux, dla porównania",
  "The previous report: the last 100 days, browsers that report to Mux only.": "Poprzedni raport: ostatnie 100 dni, tylko przeglądarki, które przesyłają dane do Mux.",
  "analytics|Other": "Inne",
  "Analytics are updated every hour. They show here within an hour of people watching.": "Statystyki są aktualizowane co godzinę. Pojawiają się tutaj najpóźniej godzinę po obejrzeniu.",
  "Counted from {date}; the viewing before it is further down.": "Liczone od {date}; oglądanie sprzed tej daty znajdziesz niżej.",
  "Counted from {date}; the viewing before it wasn't counted.": "Liczone od {date}; oglądanie sprzed tej daty nie zostało policzone.",
  "Live viewing during {times} isn't fully counted: our video network didn't save all its logs for that time.": "Oglądanie na żywo w czasie {times} nie jest w pełni policzone: nasza sieć wideo nie zapisała wszystkich logów z tego okresu.",
  "This event keeps its current report until {date}. Then it moves to our new analytics, which count every player and are kept for good. Export a PDF to keep a copy of this report.": "To wydarzenie zachowuje obecny raport do {date}. Potem przejdzie na nasze nowe statystyki, które liczą wszystkie odtwarzacze i są przechowywane na zawsze. Wyeksportuj plik PDF, aby zachować kopię tego raportu.",
  "Updated hourly.": "Aktualizowane co godzinę.",
  "Last updated {date}, {time}": "Ostatnia aktualizacja: {date}, {time}",
  "analytics|Live": "Na żywo",
  "analytics|Replay": "Nagranie"
}
